// extracted by mini-css-extract-plugin
export default {"form":"EditAccount_form__crrrY","formGroup":"EditAccount_formGroup__7nRRq"};